import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getSessionQueryOptions } from '@/hooks/useSession';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/react-query';

export const logout = () => {
  return api.post('/auth/logout', {}, { withCredentials: true });
};

type UseLogoutOptions = {
  mutationConfig?: MutationConfig<typeof logout>;
};

export const useLogout = ({ mutationConfig }: UseLogoutOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: logout,
    onSuccess: (data, ...args) => {
      queryClient.invalidateQueries({
        queryKey: getSessionQueryOptions().queryKey,
      });
      toast.success('Logged out successfully');
      onSuccess?.(data, ...args);
    },
    ...restConfig,
  });
};
